import React from "react";
import Navbar from "../../../navbar";
import Footer from "../../../footer";
import "./style.scss";
// import IpLocation from "ip-location";
// import axios from "axios";
import SEO from "../../../seo";

import { Link } from "gatsby";

import blogData from "../../../bloginner/data";

// import banner from "../../../../images/memoryfoamvslatexfoam.png";

export default function MemoryFoamVsLatexFoam(props) {
  const { location, data } = props;

  //   const { blogImg, blogTitle, content, date, seoDescription, seoImg } = data;

  var prev = null;
  var next = null;

  let i = 0;

  blogData.forEach((item, it) => {
    if (location.pathname.includes(item.link)) {
      i = it;
    }
  });

  if (i === 0) {
    prev = null;
  } else {
    prev = (
      <Link className="blog__bottombuttons__prev" to={blogData[i - 1].link}>
        <i class="fas fa-arrow-left"></i> Prev
      </Link>
    );
  }

  if (i === blogData.length - 1) {
    next = null;
  } else {
    next = (
      <Link className="blog__bottombuttons__next" to={blogData[i + 1].link}>
        Next <i class="fas fa-arrow-right"></i>
      </Link>
    );
  }

  return (
    <div className="blog memorylatexfoam">
      <SEO
        title={"Memory Foam vs. Latex Foam Mattresses | Eclipse International"}
        description={
          "Explore the differences between memory foam and latex foam to find the best fit for your sleeping style and comfort. "
        }
        img={""}
      />
      <Navbar />
      <div className="blog__content">
        <h1 className="blog__title">Memory Foam vs Latex Foam</h1>
        <div className="blog__header">
          <div className="blog__header__date">October 12, 2021</div>
          <div className="blog__header__socialshare">
            Share&nbsp; &nbsp;
            <span className="hicon">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-facebook-f"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://twitter.com/intent/tweet?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-twitter"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-linkedin-in"></i>
              </a>
            </span>
          </div>
        </div>
        <img
          className="blog__headerimg blog__headerimg--desktop"
          src={
            "https://eclipsemattress.in/assets/blog/memoryfoamvslatex-banner-desktop.jpg"
          }
          alt="Blog Header Image"
        ></img>
        <img
          className="blog__headerimg blog__headerimg--mobile"
          src={
            "https://eclipsemattress.in/assets/blog/memoryfoamvslatex-banner-mobile.jpg"
          }
          alt="Blog Header Image"
        ></img>

        <div className="blog__container">
          <p>
            <a href="/memory-foam/">Memory foam</a> and{" "}
            <a href="/latex/">latex mattresses</a> are often compared to each
            other- both are layered foam beds that provide adequate posture
            support.
            <br />
            <br />
            If you are headed towards mattress shopping, here’s an easy summary
            of their differences to help you make the right choice. Remember
            there’s no one mattress that is perfect for everyone! Consider
            sleeping preferences, comfort needs as well as likes and dislikes
            before making a decision.
            <br />
            <br />
            Psst, remember that you can also have the best of both memory foam
            and natural latex in one mattress!
          </p>

          <div className="row">
            <div className="col col-6">
              <h2>Memory Foam</h2>
            </div>
            <div className="col col-6">
              <h2>Latex Foam</h2>{" "}
            </div>
          </div>

          <h3>Conformity</h3>
          <div className="memorylatexfoam__table__row">
            <div className="memorylatexfoam__table__col">
              <div>
                Conforms and contours the exact shape of the sleeper - with slow
                recovery time. Excellent for joint pain relief!{" "}
              </div>
            </div>
            <div className="memorylatexfoam__table__col">
              <div>
                Compresses and bounces, and only conforms to the general
                impressions that the body makes.
              </div>
            </div>
          </div>

          <h3>Motion Transfer</h3>
          <div className="memorylatexfoam__table__row">
            <div className="memorylatexfoam__table__col">
              <div>
                Isolates motion and prevents movement transfer. Great for
                couples!
              </div>
            </div>
            <div className="memorylatexfoam__table__col">
              <div>
                Springy and bouncy, and instantly responsive! Great for those
                who prefer a more resistant and firm surface
              </div>
            </div>
          </div>

          <h3>Temperature Sensitivity</h3>
          <div className="memorylatexfoam__table__row">
            <div className="memorylatexfoam__table__col">
              <div>
                Higher heat retention for responsiveness and body cradling.
              </div>
            </div>
            <div className="memorylatexfoam__table__col">
              <div>
                Porous and promotes airflow. Smooth and cool feeling to the
                skin.
              </div>
            </div>
          </div>

          <h3>Environmental Impact</h3>
          <div className="memorylatexfoam__table__row">
            <div className="memorylatexfoam__table__col">
              <div>
                Manufactured poly foam that is naturally hypoallergenic. Also
                more affordable!
              </div>
            </div>
            <div className="memorylatexfoam__table__col">
              <div>
                The best latex comes straight from rubber trees and is
                eco-friendly and highly durable. Check the origin!
              </div>
            </div>
          </div>
        </div>

        <center>
          <div className="blog__header__socialshare">
            Share &nbsp; &nbsp;
            <span className="hicon">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-facebook-f"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://twitter.com/intent/tweet?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-twitter"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-linkedin-in"></i>
              </a>
            </span>
          </div>
        </center>

        <div className="blog__bottombuttons">
          {prev} {next}
        </div>
      </div>
      <br />
      <br />
      <br />
      <Footer />
    </div>
  );
}
